import api from './api';
import {
  CheckoMessage,
  Company,
  CompanyConnection,
  CompanyFinances,
  Contract,
  Enforcement,
  Inspection,
  LegalCase,
  TimelineEvent,
} from '../models/types';
import { AxiosResponse } from 'axios';

interface FriendForm {
  friend: number;
}

class CompanyService {
  async getFriends(): Promise<Company[]> {
    const res = await api.get('/api/v1/friends/');
    return res.data;
  }

  addFriend(form: FriendForm): Promise<AxiosResponse> {
    return api
      .post(`/api/v1/friends/`, {
        ...form,
      })
      .then((res: AxiosResponse) => {
        return res;
      });
  }

  removeFriend(id: string): Promise<void> {
    return api.delete(`/api/v1/friends/${id}`).then((res: AxiosResponse<void>) => {
      return res.data;
    });
  }
  // Получить все компании
  async all(): Promise<Company[]> {
    const res = await api.get('/api/v1/companies/');
    return res.data;
  }

  // Получить определенную компании
  async getById(id: number): Promise<Company[]> {
    const res = await api.get(`/api/v1/companies/${id}`);
    return res.data;
  }

  // Привязка к компании
  addCompany(form: any): Promise<AxiosResponse> {
    return api
      .post(`/api/v1/ticket-company-binding/`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res: AxiosResponse) => {
        return res;
      });
  }

  // Получить компании по представителю
  async getCompany(id: number): Promise<Company[]> {
    const res = await api.get(`/api/v1/companies/?representative__in=${id}`);
    return res.data;
  }

  // Получить компанию по ИНН
  async getByInn(inn: string): Promise<Company> {
    const res = await api.get('/api/v1/company/', {
      params: {
        query: inn,
      },
    });
    return res.data;
  }

  // Получить финансовые данные компании по ИНН
  async getFinances(inn: string): Promise<CompanyFinances> {
    const res = await api.get('/api/v1/company-finances/', {
      params: {
        query: inn,
      },
    });
    return res.data;
  }

  async getConnections(inn: string): Promise<CompanyConnection[]> {
    const res = await api.get('/api/v1/company-connections/', {
      params: {
        query: inn,
      },
    });
    return res.data;
  }

  async getLegalCases(inn: string): Promise<LegalCase[]> {
    const res = await api.get('/api/v1/legal-cases/', {
      params: {
        inn: inn,
      },
    });
    return res.data;
  }

  async getContracts(inn: string): Promise<Contract[]> {
    const res = await api.get('/api/v1/contracts/', {
      params: {
        inn: inn,
      },
    });
    return res.data;
  }

  async getInspections(inn: string): Promise<Inspection[]> {
    const res = await api.get('/api/v1/inspection/', {
      params: {
        inn: inn,
      },
    });
    return res.data;
  }

  async getEnforcements(inn: string): Promise<Enforcement[]> {
    const res = await api.get('/api/v1/enforcements/', {
      params: {
        inn: inn,
      },
    });
    return res.data;
  }

  async getTimeline(inn: string): Promise<TimelineEvent[]> {
    const res = await api.get('/api/v1/timeline/', {
      params: {
        inn: inn,
      },
    });
    return res.data;
  }

  async getFedresurs(inn: string): Promise<CheckoMessage[]> {
    const res = await api.get('/api/v1/fedresurs/', {
      params: {
        inn: inn,
      },
    });
    return res.data;
  }

  async getBankruptcyMessages(inn: string): Promise<CheckoMessage[]> {
    const res = await api.get('/api/v1/bankruptcy-messages/', {
      params: {
        inn: inn,
      },
    });
    return res.data;
  }

  async updateCompanyData(inn: string): Promise<any> {
    const res = await api.get(`/api/v1/company-update/?query=${inn}`);
    return res.data;
  }

  // Получить предпринимателя по ИП
  async getByIP(ip: string): Promise<Company> {
    const res = await api.get('/api/v1/entrepreneur/', {
      params: {
        query: ip,
      },
    });
    return res.data;
  }

  // Поиск компаний только через основной backend API
  async searchCompanies(query: string): Promise<Company[]> {
    return this.companySearch(query);
  }

  // Поиск компаний через основной API
  async companySearch(query: string): Promise<Company[]> {
    const res = await api.get('/api/v1/company-search', {
      params: {
        query,
      },
    });
    return res.data;
  }
}

export default new CompanyService();
